import { Button } from '@/components/_ui/Button'
import T, { useTranslate } from '@/components/Helpers/Translate'
import { useModals } from '@/components/ModalManager/useModals'
import type { HydraGetShipToOption } from '@/lib/services/Hydra/shipToOptions/hydraGetShipToOptions'
import useGlobalStore from '@/store/useGlobalStore'
import Image from 'next/image'
import type { Dispatch, SetStateAction } from 'react'
import React from 'react'
import { LocationChangeForm } from '../LocationChangeForm'

type Props = {
  shipToOptions: HydraGetShipToOption[] | null
  activeLocation: number
  setActiveLocation: Dispatch<SetStateAction<number>>
  isLoadingShipToOptions: boolean
}

export const DeliveringTo = ({
  shipToOptions,
  activeLocation,
  setActiveLocation,
  isLoadingShipToOptions,
}: Props) => {
  const {
    user: { isSignedIn },
  } = useGlobalStore()

  const { translate } = useTranslate()
  const { modals } = useModals()

  const handleOpenLocationDialog = () => {
    modals.openModal({
      type: 'modal',
      modalId: 'change-location-form',

      modal: {
        title: translate(
          isSignedIn ? 'choose_your_location' : 'enter_a_zip_code',
        ),
        className: 'max-w-xl py-8!',
        children: (
          <LocationChangeForm
            shipToOptions={shipToOptions}
            isLoadingShipToOptions={isLoadingShipToOptions}
            handleConfirmForm={(selectedAddress) => {
              modals.closeModals()
              setActiveLocation(selectedAddress)
            }}
          />
        ),
      },
    })
  }

  if (!isSignedIn) return null
  if (!shipToOptions) return null
  if (!shipToOptions[activeLocation]) return null

  return (
    <div className="align-center flex flex-row px-5 py-2">
      <Image
        className="mr-5 h-3.5"
        alt={translate('delivering_to')}
        src="/icons/location.svg"
        width={15}
        height={15}
      />

      <div className="flex flex-col md:flex-row">
        <div>
          <span className="pr-1 font-medium">
            <T>delivering_to</T>
          </span>
          {shipToOptions && (
            <span className="pr-1">
              {`${shipToOptions[activeLocation].shipToAddress.city} ${shipToOptions[activeLocation].shipToAddress.zip} `}{' '}
              -
            </span>
          )}
        </div>

        <Button
          className="h-full justify-start p-0 text-xs underline"
          onClick={handleOpenLocationDialog}
          variant="link"
        >
          <T>update_location</T>
        </Button>
      </div>
    </div>
  )
}
